import React from 'react';
import { IonIcon } from '@ionic/react';
import { closeCircle } from 'ionicons/icons';
import styles from './ClearButton.module.css';

/** The grey ⓧ at a row's end that clears or removes its value. */
const ClearButton: React.FC<{
  label: string;
  testId: string;
  onClick: () => void;
}> = ({ label, testId, onClick }) => (
  <button
    type="button"
    slot="end"
    className={styles.clearButton}
    aria-label={label}
    data-testid={testId}
    onClick={onClick}
  >
    <IonIcon icon={closeCircle} aria-hidden="true" />
  </button>
);

export default ClearButton;
